/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Spokenlanguage1Inputs */

const de__field_spokenlanguage1 = /** @type {(inputs: _Field_Spokenlanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gesprochene Sprache`)
};

/**

* @param {_Field_Spokenlanguage1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_spokenlanguage1 = /** @type {((inputs?: _Field_Spokenlanguage1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Spokenlanguage1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_spokenlanguage1(inputs)
});
export { _field_spokenlanguage1 as "_field_spokenLanguage" }